import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=ee341f9a"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports